// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { deserialize_BookmarkResponse } from "@newgenerated/shared/serializerDeserializer/BookmarkResponse";

export async function toggleBookmarkActionable(props: { actionableId: bigint }): Promise<ApiResult<schema.BookmarkResponse>> {
  let path = "/gaapi/actionables/{actionableId}/bookmark";
  path = path.replace(
    "{actionableId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.actionableId),
  );
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.BookmarkResponse> => {
    return deserialize_BookmarkResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error", errorCode: null, errorMessage: "deserialize failed" };
  }
  return { kind: "success", data: deserialized.value };
}
